module.exports = __webpack_public_path__ + "img/myAddr.e5c482a5.png";